import { Link } from "react-router-dom";
import { Minus, Plus, X, ArrowRight, ShoppingBag } from "lucide-react";
import { useShop } from "../store/ShopContext";
import { formatPrice } from "../lib/api";
import { PageHeader } from "../components/PageHeader";

export default function Cart() {
  const { cart, cartTotal, updateQty, removeFromCart } = useShop();
  const shipping = cartTotal >= 500 || cartTotal === 0 ? 0 : 29;

  return (
    <div data-testid="cart-page">
      <PageHeader eyebrow="Coș" title="Coșul tău" crumbs={[{ label: "Coș" }]} testId="cart-header" />
      <div className="container-cc">
        {cart.length === 0 ? (
          <div data-testid="cart-empty" className="surface py-24 text-center">
            <ShoppingBag size={36} strokeWidth={1} className="mx-auto text-[#B4A38E] mb-5" />
            <p className="font-serif text-3xl">Coșul este gol</p>
            <p className="text-sm text-[#737373] mt-2">Adaugă un cărucior sau un scaun auto din colecția THULE.</p>
            <Link to="/catalog" className="btn-primary mt-8">Explorează catalogul</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <ul className="lg:col-span-8 divide-y divide-black/10 border-y border-black/10">
              {cart.map((item) => (
                <li key={item.key} data-testid={`cart-item-${item.slug}${item.variant ? `-${item.variant.replace(/\s/g, "-").toLowerCase()}` : ""}`} className="py-6 flex gap-5 sm:gap-8">
                  <Link to={`/produs/${item.slug}`} className="surface w-28 h-32 sm:w-36 sm:h-40 flex items-center justify-center p-3 shrink-0">
                    <img src={item.image} alt={item.name} className="product-img max-h-full object-contain" />
                  </Link>
                  <div className="flex-1 flex flex-col">
                    <div className="flex justify-between gap-4">
                      <div>
                        <Link to={`/produs/${item.slug}`} className="font-serif text-xl sm:text-2xl leading-tight hover:text-[#B4A38E] transition-colors">{item.name}</Link>
                        <p className="text-xs text-[#737373] mt-1">{item.variant || item.color}</p>
                      </div>
                      <button data-testid={`cart-remove-${item.slug}`} aria-label="Elimină" onClick={() => removeFromCart(item.key)} className="text-[#737373] hover:text-[#0A0A0A] h-fit"><X size={18} strokeWidth={1.5} /></button>
                    </div>
                    <div className="mt-auto flex items-center justify-between pt-4">
                      <div className="inline-flex items-center border border-black/15">
                        <button data-testid={`cart-dec-${item.slug}`} aria-label="Scade" className="h-9 w-9 flex items-center justify-center hover:bg-[#F2F2EF]" onClick={() => updateQty(item.key, item.qty - 1)}><Minus size={12} /></button>
                        <span data-testid={`cart-qty-${item.slug}`} className="w-9 text-center text-sm">{item.qty}</span>
                        <button data-testid={`cart-inc-${item.slug}`} aria-label="Crește" className="h-9 w-9 flex items-center justify-center hover:bg-[#F2F2EF]" onClick={() => updateQty(item.key, item.qty + 1)}><Plus size={12} /></button>
                      </div>
                      <p className="font-semibold">{formatPrice(item.price * item.qty)}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <aside className="lg:col-span-4">
              <div className="surface p-8 lg:sticky lg:top-[132px]">
                <p className="font-serif text-2xl mb-6">Sumar</p>
                <dl className="space-y-3 text-sm">
                  <div className="flex justify-between"><dt className="text-[#737373]">Subtotal</dt><dd data-testid="cart-subtotal" className="font-medium">{formatPrice(cartTotal)}</dd></div>
                  <div className="flex justify-between"><dt className="text-[#737373]">Livrare (estimat)</dt><dd className="font-medium">{shipping === 0 ? "Gratuit" : formatPrice(shipping)}</dd></div>
                  <div className="flex justify-between border-t border-black/10 pt-4 text-base"><dt className="font-semibold">Total</dt><dd data-testid="cart-total" className="font-semibold">{formatPrice(cartTotal + shipping)}</dd></div>
                </dl>
                <p className="text-xs text-[#9A9A9A] mt-4">Demo: valorile de livrare sunt orientative și nu reprezintă o ofertă.</p>
                <Link to="/checkout" data-testid="cart-checkout-btn" className="btn-primary w-full mt-8">Finalizează comanda <ArrowRight size={16} /></Link>
                <Link to="/catalog" className="btn-ghost mt-6">Continuă cumpărăturile</Link>
              </div>
            </aside>
          </div>
        )}
      </div>
    </div>
  );
}
